import React from 'react';
import { Modal, View, Text, TextInput, TouchableOpacity, StyleSheet } from 'react-native';
import { BlurView } from 'expo-blur';
import { GlassBackgroundGradient, GradientOverlay } from './Gradients';
import GradientText from './GradientText';

/**
 * ShareBetSlipModal — extracted from SgpFlowScreen (god-file decomposition).
 *
 * Also fixes a latent crash: the inline version referenced `Modal` and
 * `GradientText` without importing them in SgpFlowScreen, so opening the
 * share dialog would throw at render time.
 */
const ShareBetSlipModal = ({ visible, shareUrl, onCopy, onClose }) => {
    if (!visible) return null;
    return (
        <Modal
            visible={visible}
            transparent={true}
            animationType="fade"
            onRequestClose={onClose}
        >
            <View style={styles.shareModalOverlay}>
                <BlurView intensity={60} tint="dark" style={styles.shareModalBlur}>
                    <View style={styles.shareModalContainer}>
                        <GlassBackgroundGradient borderRadius={20} />
                        <GradientOverlay opacity={0.3} borderRadius={20} />

                        <View style={styles.shareModalContent}>
                            <GradientText style={styles.shareModalTitle}>
                                Share Your BetSlip
                            </GradientText>
                            <Text style={styles.shareModalDescription}>
                                Copy this link to share your betslip with others
                            </Text>

                            <View style={styles.shareUrlContainer}>
                                <TextInput
                                    style={styles.shareUrlInput}
                                    value={shareUrl}
                                    editable={false}
                                    multiline
                                />
                                <TouchableOpacity
                                    onPress={onCopy}
                                    style={styles.copyButton}
                                >
                                    <Text style={styles.copyButtonText}>Copy</Text>
                                </TouchableOpacity>
                            </View>

                            <TouchableOpacity
                                onPress={onClose}
                                style={styles.shareCloseButton}
                            >
                                <Text style={styles.shareCloseButtonText}>Close</Text>
                            </TouchableOpacity>
                        </View>
                    </View>
                </BlurView>
            </View>
        </Modal>
    );
};

const styles = StyleSheet.create({
    shareModalOverlay: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 20,
    },
    shareModalBlur: {
        width: '100%',
        maxWidth: 400,
        borderRadius: 20,
        overflow: 'hidden',
    },
    shareModalContainer: {
        position: 'relative',
        padding: 24,
    },
    shareModalContent: {
        position: 'relative',
        zIndex: 2,
    },
    shareModalTitle: {
        fontSize: 24,
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: 8,
    },
    shareModalDescription: {
        fontSize: 16,
        color: 'rgba(255, 255, 255, 0.8)',
        textAlign: 'center',
        marginBottom: 20,
    },
    shareUrlContainer: {
        marginBottom: 20,
    },
    shareUrlInput: {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderWidth: 1,
        borderColor: 'rgba(255, 255, 255, 0.2)',
        borderRadius: 8,
        paddingHorizontal: 12,
        paddingVertical: 10,
        fontSize: 12,
        color: 'rgba(255, 255, 255, 0.8)',
        marginBottom: 12,
        minHeight: 60,
    },
    copyButton: {
        alignSelf: 'center',
        paddingVertical: 8,
        paddingHorizontal: 16,
        backgroundColor: 'rgba(74, 222, 128, 0.15)',
        borderRadius: 6,
        borderWidth: 1,
        borderColor: '#4ade80',
    },
    copyButtonText: {
        color: '#4ade80',
        fontSize: 14,
        fontWeight: '600',
    },
    shareCloseButton: {
        height: 48,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderRadius: 12,
        borderWidth: 1,
        borderColor: 'rgba(255, 255, 255, 0.2)',
    },
    shareCloseButtonText: {
        color: 'rgba(255, 255, 255, 0.8)',
        fontSize: 16,
        fontWeight: '500',
    },
});

export default ShareBetSlipModal;
